import { render, staticRenderFns } from "./insurance-bss-report.vue?vue&type=template&id=1e99e32c&scoped=true"
import script from "./insurance-bss-report.vue?vue&type=script&lang=ts"
export * from "./insurance-bss-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e99e32c",
  null
  
)

export default component.exports